import { useEffect, useState } from 'react'
import type { ArticleSummary } from 'services/ContentfulService/models/articles'
import { Hero } from '../../../shared/layout/Hero'
import { Heading, Paragraph, Typography } from 'ui/typography'
import { Container } from 'shared/layout/Container'
import { Box } from 'ui/primitives'
import { ArticleSection } from 'shared/learn/ArticleSection'
import { View } from 'reshaped/bundle'

type Props = { articles: Array<ArticleSummary> }

export const Savings = ({ articles }: Props) => {
	const [isReady, setIsReady] = useState(false)

	useEffect(() => {
		if (customElements.get('moneylion-banking')) {
			setIsReady(true)
			return
		}

		const script = document.createElement('script')
		script.src = 'https://www.moneylion.com/network/fiona/banking/web-component/banking/index.js'
		script.type = 'application/javascript'
		script.async = true

		script.onload = () => {
			if (customElements.get('moneylion-banking')) {
				setIsReady(true)
			} else {
				console.warn('Banking script loaded, but component not registered')
			}
		}

		script.onerror = () => {
			console.error('Failed to load moneylion-banking web component')
		}

		document.body.appendChild(script)

		return () => {
			document.body.removeChild(script)
		}
	}, [])

	return (
		<>
			<Hero>
				<Heading.H1>
					Find a <Typography color={'secondary.main'}>savings account.</Typography>
				</Heading.H1>
				<Paragraph>Choose from the top high-yield savings account offers from the top institutions.</Paragraph>
			</Hero>
			<Container>
				{/* @ts-ignore - web-components must not be self-closing */}
				<View paddingTop={8}>{isReady && <moneylion-banking />}</View>
				<Box paddingY={'xxl'}>
					<ArticleSection articles={articles} />
				</Box>
			</Container>
		</>
	)
}
